import { AmplitudeAnalyticsLogger } from './lib/amplitude-analytics-logger';

export default new AmplitudeAnalyticsLogger();
